import { formatMoment, type StaffLanguage } from './staffText'
import type { AccessToken } from './types'

export type TokenState = 'active' | 'expired' | 'revoked'
export type ExpiryDays = 7 | 30 | 90 | 365 | null

export const EXPIRY_CHOICES: readonly ExpiryDays[] = [7, 30, 90, 365, null]
export const DEFAULT_EXPIRY: ExpiryDays = 90

/** How many stopped tokens the list keeps under the working ones. */
const STOPPED_SHOWN = 5

export function tokenState(t: Pick<AccessToken, 'expiresAt' | 'revokedAt'>, now: number = Date.now()): TokenState {
  if (t.revokedAt) return 'revoked'
  if (t.expiresAt && Date.parse(t.expiresAt) <= now) return 'expired'
  return 'active'
}

/** Working tokens newest first, then the latest few that stopped. */
export function shownTokens(tokens: AccessToken[], now: number = Date.now()): AccessToken[] {
  const newest = (a: AccessToken, b: AccessToken) => b.createdAt.localeCompare(a.createdAt)
  const active = tokens.filter((t) => tokenState(t, now) === 'active').sort(newest)
  const stopped = tokens.filter((t) => tokenState(t, now) !== 'active').sort(newest)
  return active.concat(stopped.slice(0, STOPPED_SHOWN))
}

/** A day, with its year when that is not this one: "30 Oct", "30 Oct 2027". */
export function tokenDate(iso: string, lang: StaffLanguage, now: number = Date.now()): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  const day = formatMoment(d, lang, { date: true })
  return d.getFullYear() === new Date(now).getFullYear() ? day : `${day} ${d.getFullYear()}`
}

export function mcpUrl(origin: string): string {
  return `${origin.replace(/\/+$/, '')}/mcp`
}

/** The one line that adds this server to Claude Code. */
export function claudeCommand(origin: string, secret: string): string {
  return `claude mcp add --transport http qmeter-queue ${mcpUrl(origin)} --header "Authorization: Bearer ${secret}"`
}
